module.exports = __webpack_public_path__ + "img/ag.51928ffb.png";